export default __webpack_public_path__ + "static/media/Panasonic BT-4LH310.1ce703a3.png";